import BrowserCallNative from './BrowserCallNative.js';
import tt from '../platformUtils/tt';

export default class TTCallNative extends BrowserCallNative {
  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在抖音小程序中暂时无法使用`));
    }
    return this[name](data);
  }

  static closeWebView() {
    return tt.navigateBack();
  }

  static call(data) {
    return tt.call(data.tel);
  }
}
